<div class="top-bar-display" [class.top-bar-display--search-opened]="isSearchingSignal()">
  <div class="top-bar-display__row">
    @if (!isLoggedIn() && isPublicNavigationEnabled()) {
      <div class="top-bar-display__column-public">
        <button
          class="top-bar-display__menu"
          (click)="toggleSideBar()"
          type="button"
          ftrButton
          title="Show Navigation Menu"
          aria-label="Show Navigation Menu"
          [autoWidth]="true"
          displayType="icon"
          [color]="buttonColor"
        >
          <ftr-icon icon="Menu" align="Middle" />
        </button>
        @if (showingBreadcrumbs) {
          <ftr-breadcrumbs class="top-bar-display__breadcrumbs" />
        }
        <div class="top-bar-display__column-public-actions">
          @if (shouldShowCartButton()) {
            <ng-container *ngTemplateOutlet="cartTemplate" />
          }
          <a ftrButton color="primary" size="extra-small" [routerLink]="loginPath">Log In</a>
          <a ftrButton color="white" size="extra-small" [routerLink]="signupPath">Sign Up</a>
        </div>
      </div>
    } @else {
      <div class="top-bar-display__column">
        <button
          class="top-bar-display__menu"
          (click)="toggleSideBar()"
          type="button"
          ftrButton
          title="Show Navigation Menu"
          aria-label="Show Navigation Menu"
          [autoWidth]="true"
          displayType="icon"
          [color]="buttonColor"
        >
          <ftr-icon icon="Menu" align="Middle" />
        </button>
        @if (!isSearchingSignal()) {
          <ftr-breadcrumbs class="top-bar-display__breadcrumbs" />
        }
      </div>
      @if (!isSearchingSignal()) {
        <div class="top-bar-display__column">
          <ng-container *ngTemplateOutlet="searchBarTemplate" />
          @if (shouldShowCartButton()) {
            <div class="top-bar-display__cart">
              <ng-container *ngTemplateOutlet="cartTemplate" />
            </div>
          }
          <ftr-account-dropdown [currentCourtSystemId]="currentCourtSystemId()" />
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="searchBarTemplate" />
      }
    }
  </div>

  @if (showingBreadcrumbs) {
    <div class="top-bar-display__breadcrumbs--mobile">
      <ftr-breadcrumbs />
    </div>
  }
</div>

<ng-template #searchBarTemplate>
  @if (currentCourtSystemId()) {
    <ftr-top-bar-search [courtSystemId]="currentCourtSystemId()!" [isSearching]="isSearchingSignal()" />
  }
</ng-template>

<ng-template #cartTemplate>
  <ftr-request-cart-side-panel-toggle [courtSystemId]="currentCourtSystemId()!" [requestType]="currentRequestType()!" />
</ng-template>
